var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGitHub(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "github",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 531 552",
    style: {
      enableBackground: "new 0 0 531 552"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M264.6,2.8C118.5,2.8,0,121.3,0,267.4c0,116.9,75.8,216.1,180.9,251.1c13.2,2.4,18.1-5.7,18.1-12.7 c0-6.3-0.2-27.2-0.4-49.3c-73.6,16-89.1-31.2-89.1-31.2c-12-30.6-29.4-38.7-29.4-38.7c-24-16.4,1.8-16.1,1.8-16.1 c26.6,1.9,40.6,27.3,40.6,27.3c23.6,40.4,61.9,28.8,77,22c2.4-17.1,9.2-28.8,16.8-35.4C157.5,377.7,95.8,355,95.8,253.6 c0-28.9,10.3-52.5,27.3-71c-2.7-6.7-11.8-33.6,2.6-70c0,0,22.2-7.1,72.8,27.1c21.1-5.9,43.7-8.8,66.2-8.9 c22.5,0.1,45.1,3,66.3,8.9c50.5-34.2,72.7-27.1,72.7-27.1c14.4,36.4,5.3,63.4,2.6,70c17,18.5,27.2,42.1,27.2,71 c0,101.6-61.9,124-120.8,130.5c9.5,8.2,17.9,24.3,17.9,49c0,35.4-0.3,63.9-0.3,72.6c0,7,4.8,15.3,18.2,12.7 c105.1-35,180.8-134.2,180.8-251C529.2,121.3,410.7,2.8,264.6,2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M100.2,382.7c-0.6,1.3-2.7,1.7-4.5,0.8c-1.9-0.9-3-2.7-2.4-4c0.6-1.4,2.6-1.7,4.6-0.8 C99.8,379.6,100.9,381.4,100.2,382.7L100.2,382.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M110.9,394.6c-1.3,1.2-3.7,0.6-5.4-1.2c-1.7-1.8-2.1-4.3-0.8-5.5c1.3-1.2,3.7-0.6,5.4,1.2 C111.9,391,112.2,393.4,110.9,394.6L110.9,394.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M121.4,409.9c-1.6,1.1-4.3,0.1-5.9-2.3s-1.6-5.2,0-6.3c1.6-1.1,4.3-0.1,5.9,2.2 C123,405.9,123,408.7,121.4,409.9L121.4,409.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M135.7,424.6c-1.5,1.6-4.5,1.2-6.8-1c-2.3-2.1-3-5.2-1.5-6.8c1.5-1.6,4.6-1.2,6.9,1 C136.5,420,137.2,423,135.7,424.6L135.7,424.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M155.4,433.1c-0.6,2.1-3.6,3-6.6,2.1s-5-3.3-4.3-5.4c0.6-2.1,3.6-3.1,6.6-2.1C154,428.6,156,431,155.4,433.1 L155.4,433.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M177,434.7c0.1,2.2-2.5,4-5.6,4c-3.2,0.1-5.7-1.7-5.8-3.8c0-2.2,2.5-4,5.6-4C174.4,430.8,177,432.6,177,434.7 L177,434.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M197.2,431.3c0.4,2.1-1.8,4.3-4.9,4.9c-3.1,0.6-5.9-0.8-6.3-2.9c-0.4-2.2,1.8-4.4,4.9-4.9 C194,427.9,196.8,429.1,197.2,431.3L197.2,431.3z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitHub);
export default __webpack_public_path__ + "static/media/GitHub.3ddd7388b620eae200904ad5239873e8.svg";
export { ForwardRef as ReactComponent };